export default __webpack_public_path__ + "static/timberline-m-20-D-FRONT-THUMB-cad317c6ee7b3eab4cb084b9a36f18ff.jpg";